export default [
    {
        text: 'Webinars',
        value: 'webinars',
        icon: 'mdi-video' ,
        path: 'webinars',
        module : 'webinars',
        permission:'MODULE_WESTUDY',
        id :'webinars',

        owner : true
    },
    {
        text: 'StudentWebinar',
        value: 'webinars_student',
        icon: 'mdi-video' ,
        path: 'webinars_student',
        module : 'webinars',
        permission:'MODULE_WESTUDY',
        id :'webinars_student',

        user : true
    }
]
